import { render, staticRenderFns } from "./GetTopRiskExposures.vue?vue&type=template&id=ba710242&scoped=true&"
import script from "./GetTopRiskExposures.vue?vue&type=script&lang=js&"
export * from "./GetTopRiskExposures.vue?vue&type=script&lang=js&"
import style0 from "./GetTopRiskExposures.vue?vue&type=style&index=0&id=ba710242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba710242",
  null
  
)

export default component.exports